(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mix-match-offer"] && !Shopify.designMode) return;
  try {
    
  const mixMatchFamilies = {
    earrings: ['Boucles d’oreilles', 'Earrings', 'Oorbellen', 'Ohrringe'], raclette_scrapers: ['Racloir à raclette'], bottle_openers: ['Décapsuleur'], wooden_pens: ['Stylo en bois'], wooden_stylus_pens: ['Stylet tactile en bois'], cork_trivets: ['Sous-plat'], slate_coasters: ['Sous-verre en ardoise'], smartphone_stands: ['Support smartphone'], hair_brushes: ['Brosse à cheveux']
  };
  const updateMixMatch = async (root) => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    if (!response.ok) return;
    const cart = await response.json();
    const productTypes = mixMatchFamilies[root.dataset.family] || [];
    const quantity = cart.items.filter((item) => productTypes.includes(item.product_type)).reduce((total, item) => total + item.quantity, 0);
    const tiers = root.dataset.tiers.split(',').map((tier) => Number(tier.split(':')[0]));
    const reached = [...tiers].reverse().find((tier) => quantity >= tier) || tiers[0];
    const next = tiers.find((tier) => tier > quantity);
    root.querySelectorAll('[data-tier]').forEach((tier) => tier.classList.toggle('is-current', Number(tier.dataset.tier) === reached));
    const progress = root.querySelector('[data-mix-match-progress]');
    if (!progress) return;
    progress.textContent = next ? root.dataset.progress.replace('[count]', String(next - quantity)).replace('[tier]', String(next)) : root.dataset.complete;
  };
  const initializeMixMatch = () => document.querySelectorAll('[data-mix-match]').forEach((root) => updateMixMatch(root).catch(() => {}));
  document.addEventListener('DOMContentLoaded', initializeMixMatch);
  document.addEventListener('cartUpdate', initializeMixMatch);
  document.addEventListener('shopify:section:load', initializeMixMatch);
  document.addEventListener('submit', (event) => { if (event.target.matches('form[action*="/cart/add"]')) window.setTimeout(initializeMixMatch, 800); });

  } catch(e) { console.error(e); }
})();
})();
